// @core/api/endpoints/team/list_role_automation_events.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRoleAutomationEventsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List role automation events
 * Returns a paginated list of role automation events. Supports filtering and sorting.
 */
export async function ListRoleAutomationEvents(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRoleAutomationEventsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/automation-events`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListRoleAutomationEventsResponse>(requestPath, { ...requestOptions, params });
}
